export const dealData = {
    loading:true,
    intervalId: null,
    hqData : {}
}